import styled from 'styled-components';

export const CoursesPlanificationWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  justify-content: space-between;
  height: 445px;
`;

export const ExpectedSubscriptionsCountWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const LoadingWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
`;
